<template>
    <div v-if="instructions.length > 0" class="text-gray-600 text-xs font-normal" v-html="instructions" />
</template>

<script setup>
const { field } = defineProps({
    field: {
        type: Object,
        required: true,
    },
})

const instructions = field.instructions && field.instructions.length > 0
    ? field.instructions.replaceAll(/\n/g, '<br>')
    : '';
</script>
